<template>

    <section class="hero is-background-light is-fullheight-with-navbar intro-section">
      <div class="hero-body">
        <div class="columns is-desktop">
          <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
            <div>
              <p class="subtitle is-5 Rational-Book">
                {{ introduction.title }}
              </p>
              <h1 class="Graphit-Bold introduction"><span v-html="introduction.description"></span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>

</template>


<script>

import { mapState } from 'vuex';

export default {
  name: 'Intro',
  props: {
  },
  methods: {
    parseHtml(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },
  },
  computed: {
    ...mapState([
      'introduction',
    ]),
  },
  mounted() {
    this.$store.dispatch('UPDATE_INTRODUCTION');
  },
};
</script>

<style scoped>

  .intro-section{
    padding-bottom: 2em;
  }

</style>
